import * as React from "react";
import { forwardRef } from "react";
const SvgFlag = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title === void 0 ? /* @__PURE__ */ React.createElement("title", { id: titleId }, "flag") : title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "#000000" }, /* @__PURE__ */ React.createElement("path", { fill: "red", d: "M21,0H3C2.447,0,2,0.448,2,1v22c0,0.552,0.447,1,1,1s1-0.448,1-1v-9h17c0.553,0,1-0.448,1-1V1 C22,0.448,21.553,0,21,0z" })));
const ForwardRef = forwardRef(SvgFlag);
export { ForwardRef as ReactComponent };
